<template>
	<div class="row">
		<div v-if="isReady" class="col-12">
			<h4>{{ $t('acte.trigger.dissociation_contrat_titre') }}</h4>
			<p>{{ $t('acte.trigger.dissociation_contrat_desc') }}</p>

			<div
				v-for="contract in contracts"
				:key="contract.avenant_id"
				class="list_contract_transfert mb-2"
			>
				<div class="row align-items-center">
					<div class="col">
						<div class="font-weight-bold">{{ contract.contract_num || $t('acte.trigger.contrat_sans_num') }}</div>
						<div class="text-muted">
							{{ contract.porteuse_nom }} — {{ contract.mare_nom }} × {{ contract.stallion_nom }}
							<span v-if="contract.tiers_rs"> — {{ contract.tiers_rs }}</span>
						</div>
					</div>
					<div class="col-auto">
						<b-button variant="primary" @click="dissociate(contract)" :disabled="processing">
							<font-awesome-icon :icon="['fal', 'check']" class="mr-1" />
							{{ $t('acte.trigger.delier_porteuse') }}
						</b-button>
					</div>
				</div>
			</div>

			<div class="text-center mt-3">
				<button @click="continueNext" class="btn btn-secondary rounded-pill" :disabled="processing">
					<font-awesome-icon :icon="['fal', 'times']" /> {{ $t('acte.trigger.ignorer') }}
				</button>
			</div>
		</div>

		<LoadingSpinner v-else class="col-12" />
	</div>
</template>

<script type="text/javascript">
import { EventBus } from 'EventBus'
import Navigation from '@/mixins/Navigation.js'
import ContractMixin from '@/mixins/Contract.js'
import Shutter from '@/mixins/Shutter.js'
import ShutterTriggers from '@/mixins/shutters-manager/Triggers.js'

export default {
	name: 'DissociationContratPorteuse',
	mixins: [Navigation, ContractMixin, Shutter, ShutterTriggers],
	props: {
		horses_ids: { type: Array, default: () => [] },
		actes_ids: { type: Array, default: () => [] },
		shutter_name: { type: String, default: () => 'dissociation_contrat_porteuse' },
		next: { type: Array, default: () => [] }
	},
	data: () => ({
		isReady: false,
		processing: false,
		contracts: []
	}),
	mounted() {
		this.init_component()
	},
	methods: {
		async init_component() {
			this.isReady = false

			let actes_ids = this.actes_ids

			// Les actes peuvent avoir été créés hors ligne : on force la synchro pour récupérer leurs ID serveur
			if(this.actes_ids.some(acte_id => acte_id < 0)) {
				await this.$sync.force(true, true)
				actes_ids = this.actes_ids.map(acte_id => this.$sync.replaceWithReplicated('horse_actes', acte_id))
			}

			this.contracts = await this.getPorteuseContractsForActes(actes_ids)

			// La porteuse n'est associée à aucun contrat de transfert : on passe au déclencheur suivant
			if(this.contracts.length === 0) {
				this.continueNext()
				return
			}

			this.isReady = true
		},
		async dissociate(contract) {
			try {
				this.processing = true
				await this.assignPorteuseToAvenant(contract.avenant_id, null)
				await this.$sync.force(true)
				this.contracts = this.contracts.filter(c => c.avenant_id !== contract.avenant_id)
			}
			finally {
				this.processing = false
			}

			// Les autres contrats restent proposés tant qu'il en reste à délier
			if(this.contracts.length === 0) {
				this.continueNext()
			}
		},
		continueNext() {
			this.shutterPanel().close(this.shutter_name)
			if(this.next.length > 0) {
				const triggered = this.next[0]
				this.next.shift()
				this.setupNewTriggered(triggered.horses, triggered.date, triggered.type, null, this.next, null, triggered.actes_ids)
			}
			else {
				EventBus.$emit('GynecologieHorse::reload')
				this.$router.push({ name: 'HorseGynecologie', params: { horse_id: this.horses_ids[0] } })
			}
		}
	},
	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
	}
}
</script>
